document.addEventListener("DOMContentLoaded", function () {

  const catalogItems = document.querySelectorAll('.catalog-item');
  if (catalogItems.length > 0) {

    catalogItems.forEach(item => {
      const btnItem = item.querySelector('.catalog-item__btn');
      const categoriesItem = item.querySelector('.catalog-item__categories');

      btnItem.addEventListener('click', () => {
        categoriesItem.classList.toggle('show-product');
      })
    })
  }
});
